import React, { Fragment, useContext, useEffect, useRef } from "react";
import { Dialog as HeadlessDialog, Transition } from "@headlessui/react";
import { DialogContext } from "contexts/DialogContext";
import { ACTIONS, STATUS } from "reducers/dialogReducer";
import { XIcon } from "@heroicons/react/solid";

export default function Dialog() {
  const closeRef = useRef();
  const { state, dispatch } = useContext(DialogContext);
  const isOpened = state.status === STATUS.OPENED;

  const closeDialog = () => {
    dispatch({ type: ACTIONS.CLOSE });
  };

  useEffect(() => {
    if (state.status === STATUS.CLOSING) {
      dispatch({ type: ACTIONS.RESET });
    }
  }, [state.status]);

  return (
    <Transition.Root show={isOpened} as={Fragment}>
      <HeadlessDialog
        as="div"
        className="relative z-50"
        onClose={closeDialog}
        initialFocus={closeRef}
      >
        <Transition.Child
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-60"
          leave="ease-in duration-200"
          leaveFrom="opacity-60"
          leaveTo="opacity-0"
          className="fixed inset-0 bg-primary"
        />

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <HeadlessDialog.Panel className="relative w-full max-w-5xl transform overflow-hidden rounded-lg bg-white p-8 lg:p-16 text-left align-middle transition-all">
                {state.title && (
                  <HeadlessDialog.Title className="mb-8 font-important text-4xl">
                    {state.title}
                  </HeadlessDialog.Title>
                )}
                {state.body}
                <div className="absolute top-4 right-4">
                  <button
                    ref={closeRef}
                    type="button"
                    onClick={closeDialog}
                    className="p-2 bg-primary text-white hover:bg-primary-dark hover:text-white transition-colors rounded-full"
                  >
                    <XIcon className="h-6 w-6" />
                    <span className="sr-only">Fermer</span>
                  </button>
                </div>
              </HeadlessDialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </HeadlessDialog>
    </Transition.Root>
  );
}
